import {
  HardDrive,
  Boxes,
  KeyRound,
  ScrollText,
  Shield,
  Receipt,
  type LucideIcon,
} from 'lucide-react';

export interface S3NavEntry {
  slug: string;
  label: string;
  icon: LucideIcon;
}

export interface S3NavGroup {
  heading: string;
  entries: S3NavEntry[];
}

/**
 * Object Storage console sidebar. The nav model already supports grouped
 * sections (each `S3NavGroup` renders its own heading), so the IAM directory —
 * Policies, Users, Groups, Roles — lives in its own "IAM" group beneath the
 * storage resources rather than a flat list.
 */
export const S3_NAV: S3NavGroup[] = [
  {
    heading: 'Object Storage',
    entries: [
      { slug: '', label: 'Overview', icon: HardDrive },
      { slug: 'buckets', label: 'Buckets', icon: Boxes },
      { slug: 'usage', label: 'Business Usage', icon: Receipt },
      { slug: 'access-keys', label: 'Access Keys', icon: KeyRound },
    ],
  },
  {
    heading: 'IAM',
    entries: [
      { slug: 'policies', label: 'Policies', icon: ScrollText },
      // Users & Groups hidden from the sidebar for now — to be reconciled with the
      // portal's existing Teams model later. Routes/pages remain wired (deep-link
      // still works); only the nav entries are withheld.
      { slug: 'iam/roles', label: 'Roles', icon: Shield },
    ],
  },
];

/** Longest nav slug that prefixes the sub-path → active sidebar entry. */
export function s3ActiveSlug(subPath: string): string {
  const slugs = S3_NAV.flatMap((g) => g.entries.map((e) => e.slug)).filter(Boolean);
  let best = '';
  for (const slug of slugs) {
    if ((subPath === slug || subPath.startsWith(`${slug}/`)) && slug.length > best.length) {
      best = slug;
    }
  }
  return best;
}
